import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { API_URL, Core_URL } from '../../../../../auth/config/constants';
import { Isupport } from '../../../../../auth/models/IUser';
import {
  OrganizationSetupStatus,
  OrganizationUpdateStatus,
} from '../models/IDashboard';

@Injectable({
  providedIn: 'root',
})
export class OnboardingService {
  constructor(private readonly http: HttpClient) {}

  saveSupportForm(support: Isupport): Observable<string> {
    return this.http.post<string>(`${API_URL.SUPPORT_URL}`, support);
  }

  updateIsIntroDone(): Observable<string> {
    return this.http.post(
      `${API_URL.UPDATE_WALTTHROUGH_STATUS}`,
      {},
      { responseType: 'text' }
    );
  }

  dashboardStatus(): Observable<OrganizationSetupStatus> {
    return this.http.get<OrganizationSetupStatus>(
      `${Core_URL.DASHBOARD_STATUS}`
    );
  }

  updateDashboardStatus(payload: OrganizationUpdateStatus): Observable<string> {
    return this.http.post<string>(
      `${Core_URL.UPDATE_DASHBOARD_STATUS}`,
      payload
    );
  }
}
